export default {
  header: {
    title: 'Utiliser vos points',
    balance: '{{value}} pts disponibles',
  },
  option_label: '{{value}} pts',
  buttons: {
    none: 'Aucun',
  },
  toasts: {
    enabled: 'Points de fidélité appliqués avec succès',
    removed: 'Points de fidélité retirés',
  },
};
